import React from 'react';
import { motion } from 'framer-motion';
import { 
  IconEnvelope, 
  IconPhone, 
  IconMapMarker, 
  IconGithub, 
  IconLinkedin
} from './icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: IconGithub, href: 'https://github.com/mendel81', label: 'GitHub' },
    { icon: IconLinkedin, href: 'https://linkedin.com/in/fernandopinilla', label: 'LinkedIn' }
  ];

  const contactInfo = [
    { icon: IconEnvelope, value: 'fpinilla@synapse.es', href: 'mailto:fpinilla@synapse.es' },
    { icon: IconPhone, value: '+34 924 31 09 30', href: 'tel:+34924310930' },
    { icon: IconMapMarker, value: 'Mérida, Badajoz, España', href: '#' }
  ];

  const usefulLinks = [
    { label: 'Synapse', href: 'https://synapse.es' },
    { label: 'Creapptiva', href: 'https://creapptiva.com' },
    { label: 'eSNews', href: '#' },
    { label: 'Blog', href: '#blog' },
    { label: 'Aviso legal', href: '#legal' },
    { label: 'Privacidad', href: '#legal' },
    { label: 'Cookies', href: '#legal' }
  ];

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      {/* Contact Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Ponte en <span className="text-primary-400">Contacto</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            ¿Tienes un proyecto en mente o quieres colaborar? 
            No dudes en contactarme, estaré encantado de hablar contigo.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-12">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold mb-6">Información de Contacto</h3>
            <div className="space-y-4">
              {contactInfo.map((info, index) => (
                <a
                  key={index}
                  href={info.href}
                  className="flex items-center text-gray-300 hover:text-white transition-colors duration-200"
                >
                  <info.icon className="mr-3 text-primary-400" size={20} />
                  <span>{info.value}</span>
                </a>
              ))}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold mb-6">Enlaces Útiles</h3>
            <div className="space-y-3">
              {usefulLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="block text-gray-300 hover:text-white transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold mb-6">Sígueme en</h3>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center text-gray-300 hover:bg-primary-600 hover:text-white transition-all duration-200"
                  aria-label={social.label}
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div>
            <div className="mt-6">
              <p className="text-gray-400 text-sm">
                También puedes encontrarme en eventos y meetups de desarrollo en Badajoz y Extremadura.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex flex-col md:flex-row justify-between items-center"
          >
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} Fernando Javier Pinilla Barrena. 
              Todos los derechos reservados.
            </div>
            <div className="flex items-center space-x-4 text-gray-400 text-sm">
              <span>Diseñado y desarrollado con ❤️ por</span>
              <a 
                href="https://synapse.es" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-400 hover:text-primary-300 transition-colors duration-200"
              >
                Synapse
              </a>
              <a href="#legal" className="hover:text-gray-200 transition-colors duration-200">
                Textos legales
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
